import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import _ from 'lodash';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import styles from './ShowMoreItems.module.scss';
const ShowMoreItems = ({ items, limit = 5, moreLimit = 0, buttonMore, buttonMin }) => {
    const { t } = useTranslation();
    let [currentItems, setCurrentItems] = useState(limit);
    const visibleItems = _.slice(items, 0, currentItems);
    const showMoreButton = visibleItems.length < items.length;
    const showMinimizeButton = items.length > limit && visibleItems.length === items.length;
    const handleShowMore = () => {
        if (moreLimit === 0) {
            setCurrentItems(items.length);
        }
        else {
            setCurrentItems((currentItems += moreLimit));
        }
    };
    const handleShowMinimize = () => {
        setCurrentItems(limit);
    };
    return (_jsxs(_Fragment, { children: [visibleItems.map((item, index) => (_jsx("div", Object.assign({ className: styles.container }, { children: item }), item.key || index))), showMoreButton &&
                (buttonMore ? (_jsx(_Fragment, { children: React.cloneElement(buttonMore, { action: handleShowMore }) })) : (_jsx(Button, Object.assign({ mode: ['secondary', 'md'], className: "col-12", onClick: handleShowMore }, { children: t('btn.more') })))), showMinimizeButton &&
                (buttonMin ? (_jsx(_Fragment, { children: React.cloneElement(buttonMin, { action: handleShowMinimize }) })) : (_jsx(Button, Object.assign({ mode: ['secondary', 'md'], className: classNames(styles.minimize, 'col-12'), onClick: handleShowMinimize }, { children: t('btn.minimize') }))))] }));
};
export default memo(ShowMoreItems);
